<template>
  <button v-show="hasNext" class="more rb" @click="more()">{{ btnTitle }}</button>
</template>

<script>
import TagList from '@/components/api/fanClub/article'

export default {
  props: ['type', 'currentPageNo', 'hasNext', 'btnTitle'],
  methods: {
    async more() {
      let type = this.type;
      let nextPageNumber = this.currentPageNo + 1;
      // 次のページがある場合
      if(this.hasNext) {
        // 新着コラム、検索、ハッシュタグ
        if(type != 'article_detail') {
          this.$emit('addList', type, nextPageNumber);
        } else {
          // 記事詳細（次のページへ）
          this.$emit('nextPage');
        }
      }
    }
  },
}
</script>

<style lang="css" scoped>
/* .more {
  border: none;
  border-radius: 100px;
  box-shadow: 0px 4px 4px 0px rgba(0, 4, 4, .25);
  background-color: #3C96FF;
  color: #fff;
  font-size: 14px;
  line-height: 1;
  padding: 20px 8px;
  width: 100%;
  position: relative;
} */

.more {
  border: none;
  border-radius: 100px;
  background-image: url(../../../assets/images/btn_more.svg);
  background-repeat: no-repeat;
  -webkit-background-size: cover;
  background-size: cover;
  background-position: center;
  color: #fff;
  font-size: 14px;
  line-height: 1;
  padding: 16px;
  width: 100%;
}
/* .more::after {
  align-items: center;
  background: linear-gradient(180deg, rgba(255, 255, 255, .72) 0%, rgba(59, 149, 255, .8) 75%);
  border-radius: 18px;
  content: 'もっと見る';
  display: flex;
  height: 90%;
  justify-content: center;
  left: 0;
  margin: auto;
  position: absolute;
  right: 0;
  top: 1px;
  width: 95%;
} */

</style>



// WEBPACK FOOTER //
// src/components/fanClub/column/MoreButton.vue